<!--下载区-->
<template>
  <div style="margin: 50px;text-align: center">
    <img src="@/assets/img/rarlog.png">
    <div style="color: #ffffff;padding-bottom: 10px">源:<a href="https://www.rarlab.com/download.htm">https://www.rarlab.com/download.htm</a></div>
    <el-button icon="el-icon-download" type="primary" plain @click="downloadWinRaR">下载</el-button>
  </div>
</template>

<script>
// import axios from 'axios';

export default {
  name: "DownloadArea",
  data(){
    return{
      filename: 'winrar-x64-602sc.exe'
    }
  },
  methods: {
    downloadWinRaR(){
      window.location.href='http://121.40.117.227:9090/download';
    }
  }
}
</script>

<style scoped>

</style>
